// extracted by mini-css-extract-plugin
export default {"section":"list_section__78o6v","buttonWrapper":"list_buttonWrapper__zMPL5"};